module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = model.data || {}\n%><div><%\nif(model.headline){\n%><div class=\"headline\"><%\n%><div class=\"content\"><%\n%><%- model.headline %><%\n%></div><%\nif(model.tooltip){\n%><%- include('../../../base/tooltip/tooltip', { model: { message: model.tooltip }, config: { orientation: 'SW-NE' } }); %><%\n}\n%></div><%\n}\nfor(const groupKey in data){\nconst group = data[groupKey] || {}\nif(utils.collectionSize(group) > 0){\n%><div class=\"head\"><%= storage.__(`scheduler.entities.project.problemSummary.headlines.${groupKey}`) %></div><%\nfor(const entityReasonSeverityType in group){\nconst details = group[entityReasonSeverityType] || {}\nconst title = storage.__(`statusFlags:${entityReasonSeverityType}`)\nconst {\nnrOfElements,\nnrOfElementsOK,\nseverity,\n} = details\nlet classes = ['element']\nif(severity){\nclasses.push(`severity severity_${severity}`)\n}\n%><div class=\"<%- classes.join(' ') %>\" style=\"--progress-width: <%- utils.number.round(100 * ((nrOfElementsOK || 0) / (nrOfElements || 1))) %>%;\"><%\n%><div class=\"progress\"><%\n%><div class=\"background\"></div><%\n%><div class=\"content\"><%\nif(nrOfElements){\n%><%= (nrOfElementsOK || 0) %> / <%= nrOfElements %><%\n} else if(severity) {\n%><%= storage.__(`statusFlags.severity.${severity}`) %><%\n}\n%></div><%\n%></div><%\n%><div class=\"title\"><%= title %></div><%\n%></div><%\n}\n}\n}\n%></div>"
  , __filename = "components/templates/core/projectTerms/problemSummary.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = model.data || {}

    ; __line = 3
    ; __append("<div>")
    ; 
if(model.headline){

    ; __line = 5
    ; __append("<div class=\"headline\">")
    ; 

    ; __line = 6
    ; __append("<div class=\"content\">")
    ; 

    ; __line = 7
    ; __append( model.headline )
    ; 

    ; __line = 8
    ; __append("</div>")
    ; 
if(model.tooltip){

    ; __line = 10
    ; __append( include('../../../base/tooltip/tooltip', { model: { message: model.tooltip }, config: { orientation: 'SW-NE' } }) )
    ; 
}

    ; __line = 12
    ; __append("</div>")
    ; 
}
for(const groupKey in data){
const group = data[groupKey] || {}
if(utils.collectionSize(group) > 0){

    ; __line = 17
    ; __append("<div class=\"head\">")
    ; __append(escapeFn( storage.__(`scheduler.entities.project.problemSummary.headlines.${groupKey}`) ))
    ; __append("</div>")
    ; 
for(const entityReasonSeverityType in group){
const details = group[entityReasonSeverityType] || {}
const title = storage.__(`statusFlags:${entityReasonSeverityType}`)
const {
nrOfElements,
nrOfElementsOK,
severity,
} = details
let classes = ['element']
if(severity){
classes.push(`severity severity_${severity}`)
}

    ; __line = 30
    ; __append("<div class=\"")
    ; __append( classes.join(' ') )
    ; __append("\" style=\"--progress-width: ")
    ; __append( utils.number.round(100 * ((nrOfElementsOK || 0) / (nrOfElements || 1))) )
    ; __append("%;\">")
    ; 

    ; __line = 31
    ; __append("<div class=\"progress\">")
    ; 

    ; __line = 32
    ; __append("<div class=\"background\"></div>")
    ; 

    ; __line = 33
    ; __append("<div class=\"content\">")
    ; 
if(nrOfElements){

    ; __line = 35
    ; __append(escapeFn( (nrOfElementsOK || 0) ))
    ; __append(" / ")
    ; __append(escapeFn( nrOfElements ))
    ; 
} else if(severity) {

    ; __line = 37
    ; __append(escapeFn( storage.__(`statusFlags.severity.${severity}`) ))
    ; 
}

    ; __line = 39
    ; __append("</div>")
    ; 

    ; __line = 40
    ; __append("</div>")
    ; 

    ; __line = 41
    ; __append("<div class=\"title\">")
    ; __append(escapeFn( title ))
    ; __append("</div>")
    ; 

    ; __line = 42
    ; __append("</div>")
    ; 
}
}
}

    ; __line = 46
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/projectTerms/problemSummary.ejs

}